module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAmElEQVR4Ae2WxQHCUBTAAhPgsi174CNg8+AOC2CPI07dX3Jv2n5FUZQXqgw4ID+s4ZAsS+RT9xINBPEyMUG8TZwRVzwwoOI4YOCarLcBocsHF1cDe68DEkDgavMBCQrcNGAUEGMxQgPeBwwGOdBASgNGgXTgAQODD8AScdElH3S8vraUWCEuuaIIn1QZcUQceqRPlScURbkDodck7CoHMysAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Dashboard/baseline_create_new_folder_black_24dp.png
// module id = 121
// module chunks = 0